import { useI18n } from "@/i18n/I18nProvider";
import { useAuth } from "@/context/AuthContext";

export const LanguageToggle = ({ dark = false, testIdPrefix = "lang-toggle" }) => {
  const { lang } = useI18n();
  const { changeLanguage } = useAuth();
  const base = dark ? "border-white/20 bg-white/5" : "border-[#E5E7EB] bg-white";
  return (
    <div className={`inline-flex rounded-full border p-0.5 ${base}`} role="group" aria-label="Language">
      {["es", "en"].map((l) => {
        const on = lang === l;
        const cls = on
          ? "bg-[#FEB601] text-[#000B45]"
          : dark ? "text-white/80 hover:text-white" : "text-gray-600 hover:text-[#000B45]";
        return (
          <button
            key={l}
            type="button"
            data-testid={`${testIdPrefix}-${l}`}
            aria-pressed={on}
            onClick={() => changeLanguage(l)}
            className={`min-w-[44px] rounded-full px-3 py-1.5 text-xs font-bold uppercase tracking-wider transition-colors ${cls}`}
          >
            {l}
          </button>
        );
      })}
    </div>
  );
};
